
<h1 class="title-page"> {{ "Menu-1" | translate }} </h1>

<div class="video-container" style="padding-left: 7px; padding-right: 7px;">
  <div class="video-wrapper">
    <div>
      <div class="video-box">
        <h3 style="text-align: center;">Allocation Calculator </h3>
        <div class="youtube-container">
          <youtube-player
            [videoId]="getFrameVideo(videoAC)"
            [width]="getWidth()"
            [height]="getHeight()"
            suggestedQuality="highres">
          </youtube-player>
        </div>
      </div>
    </div>

    <div>
      <div class="video-box">
        <h3 style="text-align: center;">Goal Planner </h3>
        <div class="youtube-container">
          <youtube-player
            [videoId]="getFrameVideo(videoGP)"
            [width]="getWidth()"
            [height]="getHeight()"
            suggestedQuality="highres">
          </youtube-player>
        </div>
      </div>
    </div>
  </div>
</div>
